
import { Component, Vue } from 'vue-property-decorator'

/**
 * 認証メールからの遷移先クッションページ
 */
@Component
export default class TokenCheck extends Vue {
  /**
   * 開始時の処理(自動遷移を行うため全てここで処理する)
   */
  private async created(): Promise<void> {
    const token = this.$route.query.token
    if (!token || typeof token !== 'string') {
      // トークン指定不正時はログイン画面へ遷移
      await this.$router.push('/activate/login')
      return
    }
    // トークンが存在する場合はパスワード設定画面へ遷移
    await this.$router.push({ path: '/activate/password', query: { token: token } })
  }
}
